import { useCallback } from "react";
export function useReactions(todo, onUpdate) {
  const toggleReaction = useCallback(emoji => {
    const reactionsMap = new Map(Object.entries(todo.reactions ?? {}));
    const users = reactionsMap.get(emoji) ?? [];
    const isReacted = users.includes("me");
    const newUsers = isReacted ? users.filter(u => u !== "me") : [...users, "me"];
    if (newUsers.length === 0) {
      reactionsMap.delete(emoji);
    } else {
      reactionsMap.set(emoji, newUsers);
    }
    onUpdate(todo.id, {
      reactions: Object.fromEntries(reactionsMap)
    });
  }, [onUpdate, todo.id, todo.reactions]);
  const handleReactionClick = useCallback(e => {
    e.stopPropagation();
    const emoji = e.currentTarget.dataset.emoji;
    if (emoji) {
      toggleReaction(emoji);
    }
  }, [toggleReaction]);
  const handleReactionSelect = useCallback(emoji => {
    toggleReaction(emoji);
  }, [toggleReaction]);
  return {
    toggleReaction,
    handleReactionClick,
    handleReactionSelect
  };
}
